import {
    AfterViewInit,
    Component,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    ViewChild,
} from "@angular/core";
import { EmbryoService } from "../../Services/Embryo.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { ReactivityService } from "src/app/Services/reactivity.service";
import { MarketingService } from "src/app/Services/marketing.service";
import { ShareDialogComponent } from "src/app/Templates/share-dialog/share-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "embryo-ImgZoom",
    templateUrl: "./ImgZoom.component.html",
    styleUrls: ["./ImgZoom.component.scss"],
})
export class ImgZoomComponent implements OnInit, OnChanges, AfterViewInit {
    @ViewChild("zoomViewer", { static: false }) zoomViewer: any;
    @ViewChild("fullZoomImage", { static: false }) fullZoomImage: any;
    @ViewChild("zoomLens", { static: false }) zoomLens: any;
    @ViewChild("mainZoomImg", { static: false }) mainZoomImg: any;
    @ViewChild("imageGallery", { static: false }) imageGallery: any;

    @Input() imgSrc: any;
    @Input() images: any;
    @Input() videoUrl: any;
    @Input() videoThumbUrl: any;
    @Input() productName: any;
    @Input() product_variant: any;
    @Input() environmentVariables: any;
    @Input() detailData: any;
    public zoomImage: any;
    public lang: string;
    public youtubeTrustedUrl: SafeUrl = "";
    public fullZoomPreview: boolean = false;
    public video: any;
    currentZoomValue: number;
    currentImageIndex: number | null;
    currentGalleryImageIndex: number = 0;
    initMiniZomConfig: boolean;
    innerWindowWidth: number = 0;
    gallaryScrollarea = false;
    hideVideo: boolean = false;
    currentwidthZoomValue: number;
    toggleFavLoading: boolean = false;
    toggleCompareLoading: boolean = false;

    constructor(
        public embryoService: EmbryoService,
        private sanitizer: DomSanitizer,
        private reactivityService: ReactivityService,
        private marketingService: MarketingService,
        public dialog: MatDialog,
    ) {
        this.currentZoomValue = 100;
        this.currentwidthZoomValue = 0;
        this.currentImageIndex = null;
        this.lang = localStorage.getItem("lang") || "en";
        this.initMiniZomConfig = true;
        embryoService.emitLang.subscribe((lang: string) => {
            this.lang = lang;
        });
    }

    ngOnInit() {
        this.innerWindowWidth = window.innerWidth;
        this.zoomImage = this.imgSrc;
        this.video = this.videoUrl;
        if (this.images.length > 0) {
            this.getImagePath(this.images[0]?.url, 0, "image", true);
        } else if (this.imgSrc) {
            this.getImagePath(this.imgSrc, 0, "image", true);
        }
    }

    ngOnChanges() {
        this.zoomImage = this.imgSrc;
        this.video = this.videoUrl;
        this.getYouTubeUrl();
        this.getCurrentImageIdx();
        this.checkWidthOverflow();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.gallaryScrollarea = true;
            this.checkWidthOverflow();
        }, 0);
    }

    @HostListener("window:orientationchange", ["$event"])
    onOrientationChange(event: any) {
        this.innerWindowWidth = window.innerWidth;
        this.checkWidthOverflow();
    }

    onMouseMove(e: any) {
        if (window.innerWidth >= 1280) {
            let image, offsetX, offsetY, x, y, zoomer;
            image = e.currentTarget;
            offsetX = e.offsetX;
            offsetY = e.offsetY;
            x = (offsetX / image.offsetWidth) * 100;
            y = (offsetY / image.offsetHeight) * 100;
            zoomer = this.zoomViewer.nativeElement.children[0];
            if (zoomer) {
                zoomer.style.backgroundPosition = x + "% " + y + "%";
                zoomer.style.display = "block";
                zoomer.style.height = image.height + "px";
                zoomer.style.width = image.width + "px";
                /*set lens:*/
                this.zoomLens.nativeElement.style.display = "block";
            }
        }
    }

    onMouseLeave() {
        this.zoomViewer.nativeElement.children[0].style.display = "none";
        this.zoomLens.nativeElement.style.border = "none";
        this.initMiniZomConfig = true;
    }

    miniZoomImage(e: any) {
        /* Refer to https://www.w3schools.com/howto/howto_js_image_zoom.asp */

        /*Set Main Data */
        const prop = {
            img: <any>null,
            lens: <any>null,
            result: <any>null,
            cx: <any>null,
            cy: <any>null,
        };
        prop.img = this.mainZoomImg.nativeElement;
        prop.result = this.zoomViewer.nativeElement.children[0];
        prop.lens = this.zoomLens.nativeElement;

        if (this.initMiniZomConfig) {
            /*Show Floating zoom result */
            prop.result.style.display = "block";

            /*set lens border to show it*/
            prop.lens.style.border = "2px solid var(--brand-color)";

            /*calculate the ratio between result DIV and lens:*/
            prop.cx = prop.result.offsetWidth / prop.lens.offsetWidth;
            prop.cy = prop.result.offsetHeight / prop.lens.offsetHeight;

            /*set background properties for the result DIV:*/
            prop.result.style.backgroundImage = "url('" + prop.img.src + "')";
            prop.result.style.backgroundSize =
                prop.img.width * prop.cx +
                "px " +
                prop.img.height * prop.cy +
                "px";

            /*result.style.backgroundSize = 200 + '%';*/
            prop.result.style.height = prop.img.height + "px";
            prop.result.style.width = prop.img.width + "px";
        }

        this.moveLens(e, prop);
    }

    moveLens(e: any, prop: any) {
        let pos, x, y;
        /*prevent any other actions that may occur when moving over the image:*/
        /*e.preventDefault();*/

        /*get the cursor's x and y positions:*/
        pos = this.getCursorPos(e, prop);

        /*calculate the position of the lens:*/
        x = pos.x - prop.lens.offsetWidth / 2;
        y = pos.y - prop.lens.offsetHeight / 2;

        /*prevent the lens from being positioned outside the image:*/
        if (x > prop.img.width - prop.lens.offsetWidth) {
            x = prop.img.width - prop.lens.offsetWidth;
        }
        if (x < 0) {
            x = 0;
        }
        if (y > prop.img.height - prop.lens.offsetHeight) {
            y = prop.img.height - prop.lens.offsetHeight;
        }
        if (y < 0) {
            y = 0;
        }
        /*set the position of the lens:*/
        prop.lens.style.left = x + "px";
        prop.lens.style.top = y + "px";

        /*display what the lens "sees":*/
        prop.result.style.backgroundPosition =
            "-" + x * prop.cx + "px -" + y * prop.cy + "px";
    }

    getCursorPos(e: any, prop: any) {
        let a, x: number, y: number;
        /*get the x and y positions of the image:*/
        a = prop.img.getBoundingClientRect();

        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;

        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;

        if (this.lang === "en") {
            return { x: x + 70, y: y + 60 };
        } else {
            return { x: x + 180, y: y + 60 };
        }
    }

    getYouTubeUrl() {
        // Get YouTube Video Id From URl then Put in Trusted Embedded Safe URl //
        if (this.video) {
            const url = this.video.split(
                /(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/
            );
            const youTubeID =
                url[2] !== undefined
                    ? url[2].split(/[^0-9a-z_\-]/i)[0]
                    : url[0];
            const fullUrl = `https://www.youtube.com/embed/${youTubeID}`;
            this.youtubeTrustedUrl =
                this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
            return this.youtubeTrustedUrl;
        }
    }

    getCurrentImageIdx() {
        if (this.images && this.images.length) {
            this.currentImageIndex = Number(
                this.images.findIndex(
                    (item: any) => this.zoomImage === item.url
                )
            );
        }
    }

    toggleFullZoomPreview() {
        this.fullZoomPreview = !this.fullZoomPreview;
        if (this.fullZoomPreview) {
            this.setFullZoomInitValue();
            this.getCurrentImageIdx();
            document.body.style.overflowY = "hidden";
        } else {
            document.body.style.overflowY = "auto";
        }
    }

    zoomIn() {
        const imgWidth = this.fullZoomImage.nativeElement.offsetWidth;
        if (this.checkFullZoomWidth()) {
            this.fullZoomImage.nativeElement.style.height =
                this.currentZoomValue + 10 + "vh";
            this.currentZoomValue = this.currentZoomValue + 10;
            this.currentwidthZoomValue = this.currentwidthZoomValue + 10;
            document.getElementsByClassName(
                "full-zoom-container"
            )[0].scrollTop =
                (document.getElementsByClassName("full-zoom-image")[0]
                    .clientHeight -
                    document.getElementsByClassName("full-zoom-container")[0]
                        .clientHeight) /
                2;
        }
    }

    zoomOut() {
        const imgWidth = this.fullZoomImage.nativeElement.offsetWidth;
        if (this.currentZoomValue >= 30) {
            this.fullZoomImage.nativeElement.style.height =
                this.currentZoomValue - 10 + "vh";
            this.currentZoomValue = this.currentZoomValue - 10;
            this.currentwidthZoomValue = this.currentwidthZoomValue - 10;
        }
        document.getElementsByClassName("full-zoom-container")[0].scrollTop =
            (document.getElementsByClassName("full-zoom-image")[0]
                .clientHeight -
                document.getElementsByClassName("full-zoom-container")[0]
                    .clientHeight) /
            2;
    }

    checkFullZoomWidth() {
        const imgWidth = this.fullZoomImage.nativeElement.offsetWidth;
        /* For Mobile*/
        if (this.innerWindowWidth <= 820) {
            return true;
        }
        /* On Web Prevent zoom more than screen width*/
        if (imgWidth + 50 <= this.innerWindowWidth) {
            return true;
        } else {
            return false;
        }
    }
    selectAlternativeImage(img: any, index: number) {
        this.currentImageIndex = Number(index);
        this.zoomImage = img.url;
        this.setFullZoomInitValue();
    }

    setFullZoomInitValue() {
        if (this.innerWindowWidth <= 960 && this.innerWindowWidth > 540) {
            this.currentZoomValue = 70;
        } else if (this.innerWindowWidth <= 540) {
            this.currentZoomValue = 30;
        } else {
            this.currentZoomValue = 90;
        }
    }

    setFullZoomImageSize() {
        if (this.fullZoomImage) {
            this.fullZoomImage.nativeElement.style.height =
                this.currentZoomValue + "vh";
        }
    }

    nexImage() {
        this.setFullZoomInitValue();
        if (
            this.currentImageIndex != null &&
            this.currentImageIndex + 1 < this.images.length
        ) {
            this.currentImageIndex++;
            this.zoomImage = this.images[this.currentImageIndex].url;
        } else if (
            this.currentImageIndex != null &&
            this.currentImageIndex + 1 === this.images.length
        ) {
            this.zoomImage = this.images[this.currentImageIndex].url;
            this.currentImageIndex = this.images.length - 1;
        }
    }

    prevImage() {
        this.setFullZoomInitValue();
        if (this.currentImageIndex && this.currentImageIndex - 1 > 0) {
            this.currentImageIndex--;
            this.zoomImage = this.images[this.currentImageIndex].url;
        } else {
            this.zoomImage = this.images[0].url;
            this.currentImageIndex = 0;
        }
    }

    getImagePath(imgPath: string, index: number, type: string, hide: boolean) {
        this.currentGalleryImageIndex = Number(index);
        if (type === "image") {
            this.zoomImage = imgPath;
            this.video = "";
        } else if (type === "video") {
            this.video = this.videoUrl;
            this.zoomImage = imgPath;
        }
        this.hideVideo = hide;
    }

    checkWidthOverflow() {
        // if (this.gallaryScrollarea) {
        const parentwidth = this.imageGallery?.nativeElement?.clientWidth;
        if (
            this.images &&
            (parentwidth - 90) / 95 < this.images.length &&
            this.images.length > 0
        ) {
            this.gallaryScrollarea = true;
        } else {
            this.gallaryScrollarea = false;
        }
        // }
    }

    getNextThumbnail() {
        const parenscrollPost = this.imageGallery.nativeElement.scrollLeft + 95;
        this.imageGallery.nativeElement.scrollLeft = parenscrollPost;
    }

    getPrevThumbnail() {
        const parenscrollPost = this.imageGallery.nativeElement.scrollLeft - 95;
        this.imageGallery.nativeElement.scrollLeft = parenscrollPost;
    }

    addToFavouriteList(variant: any) {
        this.toggleFavLoading = true;
        if (!variant.is_favourite) {
            this.reactivityService.setDataToStore("currentFavProduct", variant);
            this.marketingService.cartEvents("add_to_wishlist", variant);
        }
        else {
            this.reactivityService.setDataToStore(
                "currentUnFavouriteProduct",
                variant
            );
        }
        this.toggleFavLoading = false;
    }

    addToCompareList(variant: any) {
        this.toggleCompareLoading = true;
        !variant.is_compare
            ? this.reactivityService.setDataToStore(
                "addProductToCompare",
                variant
            )
            : this.reactivityService.setDataToStore(
                "removeProductFromCompare",
                variant
            );
        this.toggleCompareLoading = false;
    }
    
    openDialogShare() {
        this.dialog.open(ShareDialogComponent, {
            data: this.detailData,
            panelClass: "product-dialog",
            height: "80vh",
        });
    }
}
